import { Navigate, Outlet } from 'react-router-dom';

import { ROUTE_PATHS } from '@/config/constants';
import { Role, useAuth } from '@/contexts/AuthContext';

interface AuthGuardProps {
  isPrivate: boolean;
}

export function AuthGuard({ isPrivate }: AuthGuardProps) {
  const { user, isLoggedIn } = useAuth();

  if (
    isLoggedIn &&
    !isPrivate &&
    user?.role.id === Role.Root &&
    !user.customer
  ) {
    return <Navigate to={ROUTE_PATHS.ADMIN_DASHBOARD} replace />;
  }

  if (isLoggedIn && !isPrivate) {
    return <Navigate to={ROUTE_PATHS.HOME} replace />;
  }

  if (!isLoggedIn && isPrivate) {
    return <Navigate to={ROUTE_PATHS.LOGIN} replace />;
  }

  return <Outlet />;
}
